/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { BiHomeAlt } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import HomeHistory from "././HomeHistory";
import HomeBookModule from "./HomeBookModule";
import "../../assets/css/home/Home.css";

const Home = () => {
  const [reload, setreload] = useState(false);
  const { t } = useTranslation();
  
  const check = () => {
    setreload(!reload);
  };

  useEffect(() => {
    if (sessionStorage.getItem("fromFirstLogin") === "1") {
      sessionStorage.removeItem("fromFirstLogin");
      window.location.reload();
    }
  }, []);

  return (
    <div className="homepage">
      {/* Book a Seat/room Content */}
      <div className="home-mobile-header d-md-none d-flex align-items-center">
        <BiHomeAlt />
        <h1>{t("home")}</h1>
      </div>
      <div className="home-module">
        <HomeBookModule />
        <HomeHistory reloader={check} />
      </div>
    </div>
  );
};

export default Home;
